import { useLocation } from 'react-router';
import { Flex } from '@/uicomponents';
import { For } from '../for';
import { matchesStepPath } from './steps';
import { useWizardSteps } from './use-wizard-steps';
import { TabItem } from './tab-item';
import styles from './wizard-tabs.module.css';

export const WizardTabs = () => {
  const { pathname } = useLocation();
  // The effective flow, not the full list — a weekly-feed-only order shows three
  // steps because Content is never walked into (NPJB-517).
  const steps = useWizardSteps();
  return (
    // The steps are a named group, not a bare row of links: without the role and label a
    // screen reader announces four unrelated links and never says what they step through.
    <Flex
      align='center'
      gap={4}
      className={styles.tabs}
      data-testid='wizard-tabs'
      role='navigation'
      aria-label='Audience builder steps'
    >
      <For
        each={[...steps]}
        renderItem={(step) => (
          <TabItem key={step.path} step={step} isActive={matchesStepPath(pathname, step.path)} />
        )}
      />
    </Flex>
  );
};
